/**
 * Component that shows the list of available profiles
 */
import ChannelGroups from './channel-groups/ChannelGroups'
import styles from './css/ProfileSection.module.css'
import ChannelSelection from './channel-selection/ChannelSelection'

export type ProfileType = {
  id: string
  isSelected: boolean
  service: { name: string }
}

export const ProfileSection = (): JSX.Element => {
  return (
    <section className={styles.selectionContainer}>
      <ChannelGroups />
      <ChannelSelection />
    </section>
  )
}
